module.exports = __webpack_public_path__ + "fonts/Inter-LightItalic.0555a46.woff";